import styles from './styles.scss'

export default `<div class="${styles.root}">
  <div class="${styles.volume}" data-ad-volume>
    <svg class="${styles.volumeIcon}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path class="${styles.muted}" fill-rule="evenodd" d="M20 0v20M0 0v20M19.35 7.35l-.7-.7a.5.5 0 0 0-.71 0L16 8.59l-1.94-1.94a.5.5 0 0 0-.7 0l-.71.7a.5.5 0 0 0 0 .71L14.59 10l-1.94 1.94a.5.5 0 0 0 0 .7l.7.71a.5.5 0 0 0 .71 0L16 11.41l1.94 1.94a.5.5 0 0 0 .7 0l.71-.7a.5.5 0 0 0 0-.71L17.41 10l1.94-1.94a.5.5 0 0 0 0-.7M8.72 16.71 5 13H2.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5H5l3.72-3.72a.75.75 0 0 1 1.28.53V16.2a.75.75 0 0 1-1.28.53"/>
      <path class="${styles.notMuted}" fill-rule="evenodd" d="M8.72 16.72 5 13H2.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5H5l3.72-3.719a.75.75 0 0 1 1.28.53V16.19a.75.75 0 0 1-1.28.53zM20 0v20V0zM0 0v20V0zm12 4.527c0-.286.241-.529.527-.504a6 6 0 0 1 0 11.955.5.5 0 0 1-.527-.504v-.802c0-.265.208-.469.471-.498A4.205 4.205 0 0 0 16.2 10a4.207 4.207 0 0 0-3.729-4.174c-.263-.029-.471-.233-.471-.498v-.801zm0 6.889c0 .325.312.587.62.487a2.002 2.002 0 0 0 0-3.805c-.308-.101-.62.162-.62.486v2.832z"/>
    </svg>
  </div>

  <div class="${styles.seek}">
    <div class="${styles.seekBar}" data-ad-seek></div>
  </div>

  <div class="${styles.label}"><%= i18n.advertisement %></div>
  <div class="${styles.blockCount}" data-ad-block-count><%= i18n.advertisement_block %> 1 <%= i18n.advertisement_block_of %> 1</span></div>

  <a class="${styles.accept}" data-ad-accept>
    <span class="${styles.acceptText}"><%= i18n.advertisement_link %></span>
    <svg class="${styles.acceptIcon}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path class="${styles.acceptLargePath}" fill-rule="evenodd" d="M0 20V0m20 0v20M7.18 16.18l-.36-.36a.5.5 0 0 1 0-.7L11.94 10 6.82 4.88a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0l5.47 5.47a1 1 0 0 1 0 1.42l-5.47 5.47a.5.5 0 0 1-.7 0"/>
      <path class="${styles.acceptSmallPath}" fill-rule="evenodd" d="M20 0v20M0 0v20m8.18-5.82-.36-.36a.5.5 0 0 1 0-.7L10.94 10 7.82 6.88a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0l3.47 3.47a1 1 0 0 1 0 1.42l-3.47 3.47a.5.5 0 0 1-.7 0"/>
    </svg>
  </a>

  <div class="${styles.previewContainer}" data-ad-preview>
    <div class="${styles.previewToggle}" data-ad-preview-show>
      <svg  class="${styles.previewToggleIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M0 20V0m20 0v20m-2-10a2 2 0 1 0-3.999-.001A2 2 0 0 0 18 10M6 10a2 2 0 1 0-3.999-.001A2 2 0 0 0 6 10m4 2a2 2 0 1 1-.001-3.999A2 2 0 0 1 10 12"/>
      </svg>
    </div>
    <div class="${styles.preview}">
      <div class="${styles.previewInner}" data-ad-skip>
        <div class="${styles.previewAction}">
          <div class="${styles.previewNoTimeLabel}"><%= i18n.advertisement_after %></div>
          <div class="${styles.previewTimeLabel}" data-ad-skip-time><%= i18n.advertisement_watch_timer %> <span></span></div>
          <div class="${styles.previewActiveLabel}"><%= i18n.advertisement_watch %></div>
        </div>
        <div class="${styles.previewImage}">
          <img src="<%=preview%>" />
          <img src="<%=preview%>" />
          <div class="${styles.previewDuration}"><%=duration%></div>
          <div class="${styles.previewLive}">Live</div>
        </div>
        <div class="${styles.previewTitle}"><%=title%></div>
      </div>
      <svg
        class="${styles.previewClose}"
        data-ad-preview-hide
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path fill-rule="evenodd" d="M20 0v20M0 0v20M14.18 6.88 11.06 10l3.12 3.12a.5.5 0 0 1 0 .7l-.36.36a.5.5 0 0 1-.7 0L10 11.06l-3.12 3.12a.5.5 0 0 1-.7 0l-.36-.36a.5.5 0 0 1 0-.7L8.94 10 5.82 6.88a.5.5 0 0 1 0-.7l.36-.36a.5.5 0 0 1 .7 0L10 8.94l3.12-3.12a.5.5 0 0 1 .7 0l.36.36a.5.5 0 0 1 0 .7"/>
      </svg>
    </div>
  </div>

  <div class="${styles.skipButton}" data-ad-skip>
    <div class="${styles.skipButtonDisabledLabel}" data-ad-skip-time><div><%= i18n.advertisement_skip_timer %> </div><span></span></div>
    <div class="${styles.skipButtonActiveLabel}"><%= i18n.advertisement_skip %></div>
  </div>

</div>
`
